export interface JobLog {
  id: string;
}

export enum LogLevel {
  Trace = 0,
  Debug = 1,
  Information = 2,
  Warning = 3,
  Error = 4,
  Critical = 5,
  None = 6
}

export enum TriggerType {
  Scheduled = 0,
  Manual = 1,
  BlobTrigger = 2,
  DistributedLockRelease = 3
}

export interface JobStatusResponse {
  id: string;
  jobName: string;
  createdAt: Date;
  state: number;
  startedAt: Date | null;
  completedAt: Date | null;
  message: string;
  instanceName: string;
  parentId: string | null;
  parent: JobStatusResponse | null;
  children: JobStatusResponse[] | null;
  jobLogs: JobLog[] | null;
  triggerType: TriggerType;
}

export interface PageLink {
  url: string;
  linkPageNumber: number;
}

export interface LoadJobStatusListResponse {
  results: JobStatusResponse[];
}

export interface PagingSorting {
  // This are populated when we get a successful response from API (extracted from http headers)
  //{"totalCount":556,"pageSize":10,"currentPage":8,"totalPages":56,"sortBy":"LongName","sortDir":0}
  totalCount: number;
  pageSize: number;
  currentPage: number;
  totalPages: number;
  sortBy: string;
  sortDir: 'Desc' | 'Asc';
}
